import { createContext, useContext } from 'react';
import { eChannelType } from 'src/providers/SocketsProvider/Sockets.enums';

export type tWapiPlanSendChannel = eChannelType | undefined | null;

export type tWapiPlanSendGuard = {
  /**
   * `true` when the send must not go out, after ONE error toast
   * (`wapiPlanReadOnly.message`). The caller returns without sending.
   */
  blockWapiPlanSend: (channel: tWapiPlanSendChannel) => boolean;
  /**
   * The same verdict, with no toast. For render decisions and for the
   * attachment loop (KTD5), where the loop shows the single toast.
   */
  isWapiPlanSendBlocked: (channel: tWapiPlanSendChannel) => boolean;
};

export const WapiPlanSendGuardContext = createContext<tWapiPlanSendGuard>({
  blockWapiPlanSend: () => false,
  isWapiPlanSendBlocked: () => false,
});

export const useWapiPlanSendGuard = (): tWapiPlanSendGuard =>
  useContext(WapiPlanSendGuardContext);
